import type { ComputedRef, InjectionKey, Ref } from 'vue';

export interface ModalContext {
    open: ComputedRef<boolean>;
    triggerId: string;
    contentId: string;
    titleId: string;
    descriptionId: string;
    /** Set while a ModalHeader with a title is mounted: the dialog is then named by it */
    hasTitle: Ref<boolean>;
    /** Set while a ModalHeader with a description is mounted: the dialog is then described by it */
    hasDescription: Ref<boolean>;
    setOpen: (open: boolean) => void;
    toggle: () => void;
    close: () => void;
}

export const modalKey: InjectionKey<ModalContext> = Symbol('Modal');

export const useModalContext = (part: string): ModalContext => {
    const context = inject(modalKey, null);
    if (!context) throw new Error(`<${part}> must be used inside <Modal>`);

    return context;
};
